import React from "react";
import { Trans } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";

export default ({ open, handleCancel, handleOk, ...other }) => {
  return (
    <Popup
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <PopupHeading id="confirmation-dialog-title">
        <Trans>Delete product?</Trans>
      </PopupHeading>
      <PopupContent dividers>
        <Trans>
          Are you sure you want to delete the product from the shopping cart?
        </Trans>
      </PopupContent>
      <PopupActions>
        <PopupButton autoFocus secondary onClick={handleCancel}>
          <Trans>Cancel</Trans>
        </PopupButton>
        <PopupButton onClick={handleOk} data-testid="confirm-delete-button">
          <Trans>Delete</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};
